"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageConfig = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
const needle_1 = require("./needle");
/**
 * Pulls a blob with image config content type.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/blobs/<digest>`
 *
 * @returns Returns HTTP response as a buffer, object, or string.
 */
async function getImageConfig(registryBase, repo, digest, username, password, options = {}, callChainObserver = { visitedUrls: [] }) {
    const endpoint = `/${repo}/blobs/${digest}`;
    const configResponse = await (0, registry_call_1.registryV2Call)(registryBase, endpoint, contentTypes.IMAGE_CONFIG, callChainObserver, username, password, options);
    return (0, needle_1.parseResponseBody)(configResponse);
}
exports.getImageConfig = getImageConfig;
//# sourceMappingURL=get-image-config.js.map